import './style.css'
import { tw } from 'utils/classnames'

export function ShimmerWrapper({
  children,
  className,
}: {
  children?: React.ReactNode
  className?: string
}) {
  return <div className={tw('shimmer-effect inline-block', className)}>{children}</div>
}
